import React, { useState } from 'react';

const ModalityWeights = ({ evidenceLayers }) => {
  const [hoveredModality, setHoveredModality] = useState(null);
  
  if (!evidenceLayers) return null;

  const modalities = Object.entries(evidenceLayers);
  const maxWeight = Math.max(...modalities.flatMap(([_, features]) => 
    (features || []).map(f => f?.weight || 0)
  ), 0.01);

  const getColor = (modality) => {
    const colors = {
      acoustic: 'bg-purple-500',
      radiology: 'bg-blue-500',
      pathology: 'bg-green-500',
      clinical: 'bg-orange-500',
      laboratory: 'bg-red-500',
      omics: 'bg-indigo-500'
    };
    return colors[modality] || 'bg-slate-500';
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6">
      <h3 className="text-sm font-semibold text-slate-700 mb-4">
        Multimodal Weight Breakdown
      </h3>
      
      <div className="space-y-4">
        {modalities.map(([modality, features]) => {
          if (!features || features.length === 0) return null;
          const avgWeight = features.reduce((sum, f) => sum + (f?.weight || 0), 0) / features.length;
          const barWidth = (avgWeight / maxWeight) * 100;
          
          return (
            <div 
              key={modality}
              className="relative"
              onMouseEnter={() => setHoveredModality(modality)}
              onMouseLeave={() => setHoveredModality(null)}
            >
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-medium text-slate-600 capitalize">
                  {modality}
                </span>
                <span className="text-xs text-slate-400">
                  {(avgWeight * 100).toFixed(0)}%
                </span>
              </div>
              <div className="h-2 bg-slate-100 rounded-full overflow-hidden">
                <div 
                  className={`h-full rounded-full transition-all duration-500 ${getColor(modality)}`}
                  style={{ width: `${Math.min(barWidth, 100)}%` }}
                />
              </div>
              
              {hoveredModality === modality && (
                <div className="absolute top-full left-0 mt-2 w-64 bg-slate-800 text-white text-xs rounded-lg p-3 z-10 shadow-lg">
                  <p className="font-medium mb-1 capitalize">{modality} Features:</p>
                  {features.slice(0, 3).map((f, i) => (
                    <div key={i} className="flex justify-between py-0.5 border-b border-slate-700/50 last:border-0">
                      <span className="truncate mr-2">{f?.description || 'Unknown feature'}</span>
                      <span className="text-indigo-300 flex-shrink-0">{((f?.weight || 0) * 100).toFixed(0)}%</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ModalityWeights;
